module.exports = __webpack_public_path__ + "static/media/supportMessagesSent_250_500.a26f2fc3.png";